<template>
  <div>
    <v-layout wrap>
      <v-flex lg1 md1 sm1 xs1>
        <pond-type-list :defaultData="pondType"  @getPondType="getPondType" @onView="onViewType"/>
      </v-flex>
      <v-flex lg11 md11 sm11 xs11>
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="classId"
            search-url="/kidClassZalo/listClassZaloByAccountZaloId"
            create-url="/kidClass/save"
            delete-url="/kidClass/delete"
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            custom-edit-item
            @editItem="openCreateDialog"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="false"
            :accept-create="false"
            @copyMission2="copyMission2"
            @copyMission3="copyMission3"
            @copyMission4="copyMission4"
            @copyMission5="copyMission5"
            @copyMission6="copyMission6"
            @copyMission7="copyMission7"
            @copyMission8="copyMission8"
            @copyMissionLink="copyMissionLink"
            @statusCheck="statusCheck"
        />
      </v-flex>
    </v-layout>

    <pond-create
        :propsItem="propsItem"
        :cDialog="visibleCreateDialog"
        :pondType="pondType"
        :areas="areas"
        :hiddenFields="hiddenFields"
        @closeCreateDialog="closeCreateDialog"
        :formCreateName="formCreateName"
    />
  </div>
</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import PondCreate from "./AccountZaloCreate.vue";
import axios from "axios";
import {cateContants, dbConstants} from "@/constants";
import PondTypeList from "./component/AccountZaloTypeList";
import {message} from "@/shared/message";

export default {
  name: "pond",
  components: {PondCreate, CSearchForm, PondTypeList},
  data: () => {
    return {
      formName: "Danh sách lớp",
      formCreateName: "Thêm mới tài khoản zalo",
      propsItem: null,
      visibleCreateDialog: false,
      accountZaloId : null,
      pondType: [],
      isActive:  false,
      mytextMessge: null,
      areas: [],
      timeReload: 0,
      pagination: {
        rowsPerPage: 10,
        page: 1,
        totalItems: 0
      },
      hiddenFields: {
        typeId: "0",
      },
      fields: [
        {
          value: "index",
          text: "STT",
          headerStyle: "text-align:center; width: 30px;",
          sortable: false,
        },
        {
          value: 'className',
          text: 'Tên lớp',
          sortable: false,
          search: true,
          headerStyle: "text-align:center; width: 80px;",
        },
        {
          value: 'programId',
          text: 'Khung chương trình',
          width: "7%",
          sortable: false,
          search: true,
          headerStyle: "text-align:center; width: 80px;",
          type: "select",
          name: "programId",
          items: [],
          itemText: "programName",
          itemValue: "programId",
        },
        {
          value: 'classLink',
          text: 'Link lớp học',
          sortable: false,
          type: "link",
          search: true,
          width: "100px",
          headerStyle: "text-align:center",
        },
        /*{
          value: 'classLink',
          text: 'Link lớp học',
          width: "10%",
          sortable: false,
          items: [
            {
              //type: "link",
              text: "Nội dung nhiệm vụ thứ 2",
              icon: "file_copy",
              event: "copyMissionLink",
              color: "primary"
            },
          ],
          event: "copyMissionLink",
          search: true,
          headerStyle: "text-align:center; width: 100px;",
        },*/
/*        {
          value: 'unitName',
          text: 'Tên Unit hiện tại',
          width: "7%",
          sortable: false,
          search: true,
          headerStyle: "text-align:center; width: 150px;",
        },*/
        {
          value: 'progress',
          text: 'Tiến độ',
          sortable: false,
          search: true,
          width: "3%",
        },
        {
          value: 'endDate',
          text: 'Ngày kết thúc',
          type: "date",
          sortable: false,
          search: false,
          dateFormat: 'dd/MM/yyyy',
          width: "5%",
          headerStyle: "text-align:center;",
          fromDate: "fromDate1",
          toDate: "toDate1"
        },

        {
          value: 'missionName',
          text: 'Nhiệm vụ hiện tại',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 100px;",
        },
        {
          value: 'totalStudentHonored',
          text: 'Tổng số học sinh được tuyên dương',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 70px;",
        },
        {
          value: "chekStatus",
          text: "Trạng thái gửi nhiệm vụ",
          headerStyle: "text-align:center; width: 50px;",
          items: [
            {
              text: "Trạng thái gửi nhiệm vụ",
              icon: "check",
              event: "statusCheck",
              color: "primary"
            },
          ],
        },
        {
          value: "custom_action_list",
          text: "Nội dung nhiệm vụ thứ 2",
          headerStyle: "text-align:center; width: 50px;",
          items: [
            {
              text: "Nội dung nhiệm vụ thứ 2",
              icon: "file_copy",
              event: "copyMission2",
              color: "primary"
            },
          ],
        },
       /* {
          value: "custom_action_list",
          text: "Nội dung nhiệm vụ thứ 3",
          headerStyle: "text-align:center; width: 50px;",
          items: [
            {
              text: "Nội dung nhiệm vụ thứ 3",
              icon: "file_copy",
              event: "copyMission3",
              color: "primary"
            },
          ],
        },*/
        /*{
          value: "custom_action_list",
          text: "Nội dung nhiệm vụ thứ 4",
          headerStyle: "text-align:center; width: 50px;",
          items: [
            {
              text: "Nội dung nhiệm vụ thứ 4",
              icon: "file_copy",
              event: "copyMission4",
              color: "primary"
            },
          ],
        },*/
        {
          value: "custom_action_list",
          text: "Nội dung nhiệm vụ thứ 5",
          headerStyle: "text-align:center; width: 50px;",
          items: [
            {
              text: "Nội dung nhiệm vụ thứ 5",
              icon: "file_copy",
              event: "copyMission5",
              color: "primary"
            },
          ],
        },
        {
          value: "custom_action_list",
          text: "Nội dung nhiệm vụ thứ 7",
          headerStyle: "text-align:center; width: 50px;",
          items: [
            {
              text: "Nội dung nhiệm vụ thứ 7",
              icon: "file_copy",
              event: "copyMission7",
              color: "primary"
            },
          ],
        }
       /* {
          value: "custom_action_list",
          text: "Nội dung nhiệm vụ thứ 6",
          headerStyle: "text-align:center; width: 50px;",
          items: [
            {
              text: "Nội dung nhiệm vụ thứ 6",
              icon: "file_copy",
              event: "copyMission6",
              color: "primary"
            },
          ],
        },
        {
          value: "custom_action_list",
          text: "Nội dung nhiệm vụ thứ 7",
          headerStyle: "text-align:center; width: 50px;",
          items: [
            {
              text: "Nội dung nhiệm vụ thứ 7",
              icon: "file_copy",
              event: "copyMission7",
              color: "primary"
            },
          ],
        },*/
        /*{
          value: "custom_action_list",
          text: "Nội dung nhiệm vụ chủ nhật",
          headerStyle: "text-align:center; width: 100px;",
          items: [
            {
              text: "Nội dung nhiệm vụ chủ nhật",
              icon: "file_copy",
              event: "copyMission8",
              color: "primary"
            },
          ],
        },*/
        /*        {
                  value: "action",
                  text: "lang.common.actions",
                  headerStyle: "text-align:center; width: 100px;",
                  compound: true,
                },*/
      ],
    };
  },

  created() {
    axios.post(
        process.env.VUE_APP_API_URL + "/kidProgram/listAllName", {status: 1}
    )
        .then(
            (data) => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "programId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
        );


    this.getPondType()
  },

  methods: {
    copyURL1(myText) {
      console.info(myText);
      navigator.clipboard.writeText(myText)
      //document.execCommand(myText);
      message.success(
          this.$t("Copy nội dung thành công")
      );
    },

    copyURLAndOpenLinkZalo(myText, linkZalo) {
      console.info(myText);
      navigator.clipboard.writeText(myText)
      let opnePage = window.open(linkZalo)
      //document.execCommand(myText);
      // console.info("chuongbv"+linkZalo);

    },
    openCreateDialog: function (item = null) {
      this.propsItem = item;
      if (item == null) {
        this.formCreateName = 'Thêm mới ao';
      } else {
        this.formCreateName = 'Cập nhật ao';
      }
      this.visibleCreateDialog = true;
    },
    closeCreateDialog: function () {
      this.propsItem = null;
      this.visibleCreateDialog = false;
      this.timeReload = Math.floor(Math.random() * 100);
    },

    statusCheck(item) {
      /*      axios.post(

                process.env.VUE_APP_API_URL + "/kidClass/listClassByAccountZaloId?pageSize=-1&page=-1",
                {accountZaloId: 3}
            ).then(
            )
            console.info(item.status + "aaaaaaaa")*/
      // console.info(localStorage.getItem("pageMsg"))
      //
      // console.info(localStorage.getItem("pageMsg"))

      axios
          .post(
              process.env.VUE_APP_API_URL +
              "/kidAccountZalo/updateStatus/" + item.classId
          )
          .then(
              (data) => {


                if (data.responseCode == "0") {
                  message.success(
                      this.$t("Đã gửi nhiệm vụ ")
                  )
                  // console.info('/accountZalo/accountList/'+this.accountZaloId)
                  // if (this.accountZaloId == null){
                  //   this.accountZaloId = 0;
                  // }
                  // /!*this.$router.push({ path: '/accountZalo/accountList/'+this.accountZaloId+ "_" + localStorage.getItem("pageMsg"), query: this.$route.query });*!/
                  // this.$router.push({ path: '/accountZalo/accountList/'+this.accountZaloId });

                } else {
                  message.error(this.$t("Không thể gửi nhiệm vụ"));
                }
              },
              (error) => {
                console.log(error);
              }
          );

    },
    copyMissionLink(item) {
      axios
          .post(
              process.env.VUE_APP_API_URL +
              "/kidAccountZalo/copyMissionLink/" + item.classId
          )
          .then(
              (data) => {
                if (data.responseCode == "0") {
                  this.copyURLAndOpenLinkZalo(data.description, data.linkZalo);
                  //window.open(data.linkZalo);
                } else {
                  message.error(this.$t("Không thể copy nội dung"));
                }
              },
              (error) => {
                console.log(error);
              }
          );
    },
    copyMission9(item) {
      axios
          .post(
              process.env.VUE_APP_API_URL +
              "/kidAccountZalo/copyMission/" + item.classId + "/9"
          )
          .then(
              (data) => {
                if (data.responseCode == "0") {
                  this.mytextMessge = data.description;
                  this.copyURL1(this.mytextMessge);
                  /*navigator.clipboard.writeText(data.description);
                  message.success(
                      this.$t("Copy nội dung thành công")
                  );*/
                } else {
                  message.error(this.$t("Không thể copy nội dung"));
                }
              },
              (error) => {
                console.log(error);
              }
          );
    },
    copyMission2(item) {
      axios
          .post(
              process.env.VUE_APP_API_URL +
              "/kidAccountZalo/copyMission/" + item.classId + "/2"
          )
          .then(
              (data) => {
                if (data.responseCode == "0") {
                  this.mytextMessge = data.description;
                  this.copyURL1(this.mytextMessge);
                  /*navigator.clipboard.writeText(data.description);
                  message.success(
                      this.$t("Copy nội dung thành công")
                  );*/
                } else {
                  message.error(this.$t("Không thể copy nội dung"));
                }
              },
              (error) => {
                console.log(error);
              }
          );
    },
    copyMission3(item) {
      axios
          .post(
              process.env.VUE_APP_API_URL +
              "/kidAccountZalo/copyMission/" + item.classId + "/3"
          )
          .then(
              (data) => {
                if (data.responseCode == "0") {
                  this.mytextMessge = data.description;
                  this.copyURL1(this.mytextMessge);
                } else {
                  message.error(this.$t("Không thể copy nội dung"));
                }
              },
              (error) => {
                console.log(error);
              }
          );
    },
    copyMission4(item) {
      axios
          .post(
              process.env.VUE_APP_API_URL +
              "/kidAccountZalo/copyMission/" + item.classId + "/4"
          )
          .then(
              (data) => {
                if (data.responseCode == "0") {
                  this.mytextMessge = data.description;
                  this.copyURL1(this.mytextMessge);
                } else {
                  message.error(this.$t("Không thể copy nội dung"));
                }
              },
              (error) => {
                console.log(error);
              }
          );
    },
    copyMission5(item) {
      axios
          .post(
              process.env.VUE_APP_API_URL +
              "/kidAccountZalo/copyMission/" + item.classId + "/5"
          )
          .then(
              (data) => {
                if (data.responseCode == "0") {
                  this.mytextMessge = data.description;
                  this.copyURL1(this.mytextMessge);
                } else {
                  message.error(this.$t("Không thể copy nội dung"));
                }
              },
              (error) => {
                console.log(error);
              }
          );
    },
    copyMission6(item) {
      axios
          .post(
              process.env.VUE_APP_API_URL +
              "/kidAccountZalo/copyMission/" + item.classId + "/6"
          )
          .then(
              (data) => {
                if (data.responseCode == "0") {
                  this.mytextMessge = data.description;
                  this.copyURL1(this.mytextMessge);
                } else {
                  message.error(this.$t("Không thể copy nội dung"));
                }
              },
              (error) => {
                console.log(error);
              }
          );
    },
    copyMission7(item) {
      axios
          .post(
              process.env.VUE_APP_API_URL +
              "/kidAccountZalo/copyMission/" + item.classId + "/7"
          )
          .then(
              (data) => {
                if (data.responseCode == "0") {
                  this.mytextMessge = data.description;
                  this.copyURL1(this.mytextMessge);
                } else {
                  message.error(this.$t("Không thể copy nội dung"));
                }
              },
              (error) => {
                console.log(error);
              }
          );
    },
    copyMission8(item) {
      axios
          .post(
              process.env.VUE_APP_API_URL +
              "/kidAccountZalo/copyMission/" + item.classId + "/8"
          )
          .then(
              (data) => {
                if (data.responseCode == "0") {
                  this.mytextMessge = data.description;
                  this.copyURL1(this.mytextMessge);
                } else {
                  message.error(this.$t("Không thể copy nội dung"));
                }
              },
              (error) => {
                console.log(error);
              }
          );
    },
    getPondType: function () {
      axios
          .post(
              process.env.VUE_APP_API_URL +
              "/kidAccountZalo/listByType?type=HA"
          )
          .then((data) => {
            if (data.length > 0) {
              this.pondType = data;
              let itemFields = this.fields.filter(function (e) {
                return e.name == "accountZaloId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }

            }
          });
    },
    onViewType(item) {
      if (item.accountZaloId != 0) {
        this.hiddenFields = Object.assign({}, {"accountZaloId": item.accountZaloId});
      } else {
        this.hiddenFields = Object.assign({}, {"accountZaloId": -1});
      }
      /*this.accountZaloId = item.accountZaloId;*/
    }
  },

  destroyed() {
  },
};
</script>
